import { render, staticRenderFns } from "./VircosGraphics.vue?vue&type=template&id=305de66e&scoped=true&"
import script from "./VircosGraphics.vue?vue&type=script&lang=js&"
export * from "./VircosGraphics.vue?vue&type=script&lang=js&"
import style0 from "./VircosGraphics.vue?vue&type=style&index=0&id=305de66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305de66e",
  null
  
)

export default component.exports